import { render, staticRenderFns } from "./inspection_summary.vue?vue&type=template&id=dda9171e&scoped=true&"
import script from "./inspection_summary.vue?vue&type=script&lang=js&"
export * from "./inspection_summary.vue?vue&type=script&lang=js&"
import style0 from "./inspection_summary.vue?vue&type=style&index=0&id=dda9171e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda9171e",
  null
  
)

export default component.exports